module.exports = __webpack_public_path__ + "static/media/flags.c33029e7.png";